// import { initializeApp } from "https://www.gstatic.com/firebasejs/9.10.0/firebase-app.js";
import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore'

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig={
  apiKey: "AIzaSyApa-8aRahTdGn10U0dh0z7Nvl1Uohfgz0",
  authDomain: "portfolio-4023b.firebaseapp.com",
  databaseURL: "https://portfolio-4023b-default-rtdb.firebaseio.com",
  projectId: "portfolio-4023b",
  storageBucket: "portfolio-4023b.appspot.com",
  messagingSenderId: "24350941224",
  appId: "1:24350941224:web:8d4f2dd46e9adc24d4151d",
  measurementId: "G-19ZZ621JLD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const firestore = app.firestore();
export default getFirestore(app);
